/**
 * Pick & Mix — EOY Gifts tab (snippets/pb-pick-mix-gifts.liquid).
 *
 * Price filter, client-side, single select. Buckets use the regular price
 * (before any Pick & Mix discount): under €15 / €30 / €50, and €50 and more.
 * - A grid hides when none of its products is in the budget.
 * - With a filter active an editorial only shows when its product is in the
 *   budget. "Alle cadeaus" shows everything.
 * - The count is the number of different products in view ("1 cadeau" /
 *   "2 cadeaus": data-template-one / data-template).
 *
 * The polaroid promo hides while a price filter is active; its button scrolls
 * to the giftboxes grid (an anchor, so it also works without JS).
 *
 * Editorial "+Add" and "i" click the add button / photo of the editorial's
 * hidden card, so the section's own basket logic and pop-up routing run. A
 * product with variants opens the pop-up on "+Add" (the card's own selector
 * would open inside the hidden wrapper).
 */
(() => {
  const BUCKETS = {
    all: () => true,
    lt15: (price) => price < 1500,
    lt30: (price) => price < 3000,
    lt50: (price) => price < 5000,
    gte50: (price) => price >= 5000,
  };

  function apply(panel, bucket) {
    const matches = BUCKETS[bucket] || BUCKETS.all;
    const priceOf = (el) => Number(el.dataset.giftsPrice || 0);

    const visible = new Set();
    for (const editorial of panel.querySelectorAll('[data-gifts-editorial]')) {
      const show = matches(priceOf(editorial));
      editorial.hidden = !show;
      if (show) visible.add(editorial.dataset.giftsProduct);
    }

    for (const group of panel.querySelectorAll('[data-gifts-group]')) {
      let groupVisible = 0;
      for (const item of group.querySelectorAll('[data-gifts-item]')) {
        const show = matches(priceOf(item));
        item.hidden = !show;
        if (show) {
          groupVisible += 1;
          visible.add(item.dataset.giftsProduct);
        }
      }
      group.hidden = groupVisible === 0;
    }

    // The polaroid promo is not a product: only in "Alle cadeaus".
    for (const promo of panel.querySelectorAll('[data-gifts-promo]')) promo.hidden = bucket !== 'all';

    for (const pill of panel.querySelectorAll('[data-gifts-bucket]')) {
      pill.setAttribute('aria-pressed', pill.dataset.giftsBucket === bucket ? 'true' : 'false');
    }

    const count = panel.querySelector('[data-gifts-count]');
    if (count) {
      const template =
        visible.size === 1 ? count.dataset.templateOne || count.dataset.template : count.dataset.template;
      count.textContent = (template || '').replace('[count]', String(visible.size));
    }

    const empty = panel.querySelector('[data-gifts-empty]');
    if (empty) empty.hidden = visible.size > 0;
  }

  function initPanel(panel) {
    if (panel.dataset.giftsReady === 'true') return;
    panel.dataset.giftsReady = 'true';

    panel.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const pill = target.closest('[data-gifts-bucket]');
      if (pill) {
        apply(panel, pill.dataset.giftsBucket);
        return;
      }

      const editorial = target.closest('[data-gifts-editorial]');
      const card = editorial?.querySelector('[data-gifts-ed-card] [data-pm-card]');
      if (!card) return;

      if (target.closest('[data-gifts-ed-add]')) {
        // The card's own variant selector sits in the hidden wrapper: let the visible pop-up ask for the variant.
        const selector = card.dataset.hasVariants === 'true' ? '.pb-pm__image-wrap' : '[data-pm-add]';
        card.querySelector(selector)?.click();
      } else if (target.closest('[data-gifts-ed-info]')) {
        card.querySelector('.pb-pm__image-wrap')?.click();
      }
    });

    apply(panel, 'all');
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-pm-gifts]').forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
